import React, { useState, useEffect, useRef } from 'react';

const FORM_ENDPOINT = 'https://public.herotofu.com/v1/23a71850-9db8-11ed-82c7-3d7607318e65';

const Contact = () => {
  const [submitted, setSubmitted] = useState(false);
  const revealRefs = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => entries.forEach((e) => {
        if (e.isIntersecting) e.target.classList.add('visible');
      }),
      { threshold: 0.15 }
    );
    const els = revealRefs.current;
    els.forEach((el) => el && observer.observe(el));
    return () => els.forEach((el) => el && observer.unobserve(el));
  }, []);

  const ref = (i) => (el) => { revealRefs.current[i] = el; };

  const handleSubmit = () => {
    setTimeout(() => setSubmitted(true), 100);
  };

  return (
    <section id="contact" className="section">
      <div className="section-header reveal" ref={ref(0)}>
        <span className="section-num">04.</span>
        <h2 className="section-title">Get In Touch</h2>
        <div className="section-line" />
      </div>

      <div className="contact-grid">
        <div className="reveal" ref={ref(1)}>
          <h3 className="contact-info-title">Need a website?</h3>
          <p className="contact-info-text">
            Whether you're starting from scratch or your current site needs a refresh,
            I'd love to help. Send me a message and I'll get back to you within a day.
          </p>
          <div className="contact-links-list">
            <a href="https://github.com/tguy5837" target="_blank" rel="noreferrer" className="contact-link-row">
              <span className="contact-link-label">GitHub</span>
              <span className="contact-link-value">github.com/tguy5837</span>
            </a>
            <a href="https://www.linkedin.com/in/douglas-guy-51a44322a/" target="_blank" rel="noreferrer" className="contact-link-row">
              <span className="contact-link-label">LinkedIn</span>
              <span className="contact-link-value">Douglas Guy</span>
            </a>
            <a href="mailto:tguy5837@gmail.com" className="contact-link-row">
              <span className="contact-link-label">Email</span>
              <span className="contact-link-value">tguy5837@gmail.com</span>
            </a>
          </div>
        </div>

        <div className="reveal reveal-delay-1" ref={ref(2)}>
          {submitted ? (
            <div className="form-submitted">
              <h3>Message sent!</h3>
              <p>Thanks for reaching out - I'll be in touch soon.</p>
            </div>
          ) : (
            <form
              className="contact-form"
              action={FORM_ENDPOINT}
              onSubmit={handleSubmit}
              method="POST"
              target="_blank"
            >
              <div className="form-group">
                <label className="form-label" htmlFor="cf-name">Name</label>
                <input id="cf-name" type="text" name="name" placeholder="Jane Smith" required />
              </div>
              <div className="form-group">
                <label className="form-label" htmlFor="cf-email">Email</label>
                <input id="cf-email" type="email" name="email" placeholder="jane@example.com" required />
              </div>
              <div className="form-group">
                <label className="form-label" htmlFor="cf-message">Message</label>
                <textarea id="cf-message" name="message" rows="5" placeholder="What's on your mind?" required />
              </div>
              <button type="submit" className="form-submit">Send Message →</button>
            </form>
          )}
        </div>
      </div>
    </section>
  );
};

export default Contact;
